import React, { useState, useEffect, useRef } from 'react';
import * as classes from './activity-feed.module.css';

interface ActivityItem {
  name: string;
  location: string;
  action: string;
  time: string;
  icon: strng | React.JSXElement | React.ReactNode;
}

interface Props {
  activities: ActivityItem[];
  currentActivity: number;
  setCurrentActivity: React.Dispatch<React.SetStateAction<number>>;
}

const ActivityFeed = ({ activities, currentActivity, setCurrentActivity } : Props) => {
  const [activityMinimized, setActivityMinimized] = useState(true);

  return (
      <div className="fixed bottom-6 right-6 z-50 select-none">
        {activityMinimized ? (
          // Minimized Pill Mode
          <button
            onClick={() => setActivityMinimized(false)}
            className="group flex cursor-pointer items-center gap-3 px-5 py-2 bg-gradient-to-r from-indigo-600/90 to-purple-600/90 backdrop-blur-xl border border-indigo-400/30 rounded-full shadow-md shadow-black/40 hover:shadow-black/60 hover:shadow-2xl transition-all duration-300 hover:scale-105"
          >
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              <span className="text-xs font-semibold text-white">
                {/*activities[currentActivity].icon*/} {activities[currentActivity].name} • {activities[currentActivity].action}
              </span>
            </div>
            <svg className="w-4 h-4 text-white/70 group-hover:text-white transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
            </svg>
          </button>
        ) : (
          // Expanded Panel Mode
          <div className="w-80 animate-fade-in">
            <div className="bg-slate-900/95 backdrop-blur-xl border border-black/50 hover:border-slate-800/50 rounded-2xl shadow-2xl shadow-[rgba(0,0,0,0.65)] overflow-hidden">
              {/* Header */}
              <div className="px-4 py-3 border-b border-slate-700/50 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                  <span className="text-sm font-semibold text-slate-200">Recent Activity</span>
                </div>
                <button 
                  onClick={() => setActivityMinimized(true)}
                  className="cursor-pointer text-slate-400 hover:text-slate-200 transition-colors p-1 hover:bg-slate-800/50 rounded-full"
                  title="Minimize"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </div>
              
              {/* Activity Items */}
              <div className="p-4 space-y-3 max-h-64 overflow-y-auto">
                {activities.slice(currentActivity, currentActivity + 3).map((activity, idx) => (
                  <div 
                    key={idx}
                    className="flex items-start gap-3 p-3 bg-slate-800/50 rounded-xl hover:bg-slate-800/70 transition-colors"
                  >
                    <div className="text-2xl">{activity.icon}</div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="text-sm font-semibold text-white truncate">{activity.name}</span>
                        <span className="text-xs text-slate-500">•</span>
                        <span className="text-xs text-slate-400 truncate">{activity.location}</span>
                      </div>
                      <p className="text-xs text-slate-400 mb-1">{activity.action}</p>
                      <span className="text-xs text-slate-500">{activity.time}</span>
                    </div>
                  </div>
                ))}
              </div>

              {/* Footer */}
              <div className="px-4 py-3 bg-slate-800/30 border-t border-slate-700/50">
                <div className="flex items-center justify-between text-xs">
                  <span className="text-slate-400">47 views this week</span>
                  <span className="text-indigo-400 font-semibold">🔥 High demand</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
  )
}

export default ActivityFeed;